import React, { useEffect, useState } from 'react';
import './style.css';
// import ButtonBack from '../buttons/back';
import { Menu } from 'react-feather';
import { useLocation } from 'react-router-dom';
import ButtonBack from '../../global-components/src/components/buttons/back';

const NavbarTop: React.FC = () => {
    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        let lastScrollY = window.scrollY;
    
        const handleScroll = () => {
            const menu = document.querySelector('.small-menu-top') as HTMLElement;
            if (!menu) return;
    
            if (window.innerWidth <= 850) {
                if (window.scrollY > lastScrollY) {
                    menu.classList.add("hidden-top-menu");
                } else {
                    menu.classList.remove("hidden-top-menu");
                }
            }
            lastScrollY = window.scrollY;
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const modalBody = document.getElementById("root") as HTMLElement | null;
        if (modalBody) {
            let lastScrollY = modalBody.scrollTop; // Correção aqui
    
            const handleScroll = () => {
                const menu = document.querySelector('.small-menu-top') as HTMLElement;
                if (!menu) return;
    
                if (window.innerWidth <= 850) {
                    if (modalBody.scrollTop > lastScrollY) { // Correção aqui
                        menu.classList.add("hidden-top-menu");
                    } else {
                        menu.classList.remove("hidden-top-menu");
                    }
                }
                lastScrollY = modalBody.scrollTop; // Correção aqui
            };
    
            modalBody.addEventListener('scroll', handleScroll); // Correção aqui
    
            return () => {
                modalBody.removeEventListener('scroll', handleScroll); // Correção aqui
            };
        }
    }, []);
    
    

    return (
        <>
            <div id='small-menu-top' className={`user-select-none small-menu-top align-items-center justify-content-between`}>
                {path != "/" && (
                    <div className="col icon-back-menu-top" style={{ width: 30 }}>
                        <ButtonBack/>
                    </div>
                )}

                {/* <div className="col d-flex justify-content-center">
                    <img src="/img/pacoca-sem-braco.png" className="cursor-pointer" alt="Logo do Read Books" height="30"/>
                </div> */}

                <div 
                    className=" col cursor-pointer icon-small-menu-top"  
                    data-bs-toggle="offcanvas" 
                    data-bs-target="#offcanvasWithBothOptions" 
                    aria-controls="offcanvasWithBothOptions"
                >
                    <Menu data-feather="menu" style={{ opacity: 0.6 }}/>
                </div>
            </div>
        </>
    );
};

export default NavbarTop;
